import { computed } from "vue";

import {
	defineOrganization,
	defineSearchAction,
	defineWebSite,
	useSchemaOrg
} from "@unhead/schema-org/vue";

import { useNuxtApp } from "#imports";

import { extractSameAsLinks } from "~/layers/base/utils/sameAsLinks";
import { siteIdentityRefs } from "~/layers/base/utils/siteIdentitySchema";

export const useSiteSchemaOrg = () => {
	const appStore = useAppStore();
	const runtimeConfig = useRuntimeConfig();
	const requestURL = useRequestURL();
	const siteConfig = useNuxtApp().$nuxtSiteConfig;
	const site = siteConfig?.get
		? siteConfig.get({ resolveRefs: true })
		: { name: "", url: "" };

	const logo = computed(
		() =>
			appStore.siteLogo?.filename ||
			appStore.footer?.logo?.filename ||
			undefined
	);
	const siteName =
		(typeof site?.name === "string" && site.name) ||
		runtimeConfig.public.siteName ||
		appStore.applicationNorce?.Name ||
		"";
	const siteUrl =
		(typeof site?.url === "string" && site.url) ||
		runtimeConfig.public.siteUrl ||
		requestURL.origin ||
		"";
	const searchTarget = siteUrl
		? `${siteUrl.replace(/\/+$/, "")}/search?q={search_term_string}`
		: "";
	const sameAs = computed(() => extractSameAsLinks(appStore.footer));

	// Single-brand templates opt into "#identity" (runtimeConfig
	// `schemaOrgSiteIdentity`): unhead then links WebSite.publisher, the home
	// WebPage.about and every Product's brand to it. See siteIdentityRefs.
	const identityRefs = siteIdentityRefs(
		runtimeConfig.public.schemaOrgSiteIdentity === true,
		// `siteUrl` is typed `{}` (runtimeConfig.public.siteUrl is untyped).
		String(siteUrl)
	);
	useSchemaOrg(
		computed(() => [
			defineOrganization({
				...identityRefs.organization,
				name: siteName,
				url: siteUrl || undefined,
				...(logo.value ? { logo: logo.value } : {}),
				...(sameAs.value.length ? { sameAs: sameAs.value } : {})
			}),
			defineWebSite({
				...identityRefs.website,
				name: siteName,
				url: siteUrl || undefined,
				...(searchTarget
					? {
							potentialAction: defineSearchAction({
								target: searchTarget,
								"query-input": "required name=search_term_string"
							})
						}
					: {})
			})
		])
	);
};
